import React from "react";
import './Search.css';


const Search =(props) =>{
    return(
        
            <div id="search">
                <div className="welcomebox justify-content-center d-grid  position-absolute w-100">
                    <h1 className="headtitle">FIND THE RIGHT BIKE</h1>
                    
                    <p className="mt-1 ptitle" >Get Comprehensive Information on Bike Prices, Specs, Reviews & More!</p>
                </div>
                <div className="d-flex wid position-absolute bar1" >
                    <input type="text" className="form-control " placeholder="Search your bike here, e.g. Royal Enfield Hunter 350" aria-label="Recipient's username" aria-describedby="button-addon2"/>
                    <button className="btn btn-dark" type="button" id="button-addon2">Search</button>
                </div>
            </div>
            
        
    )
}
export default Search;